import { useSearchParams } from 'react-router'

import { EMPTY_STRING } from '../constants/common'
import { MENU_POST_ITEM } from '../constants/menu'
import { getWebappLinkPrefix } from '../utils/route'

import { useInitData } from './useInitData'

export function useRootPath() {
  const [searchParams] = useSearchParams()
  const redirect = searchParams.get('redirect') || EMPTY_STRING

  const { availableSections } = useInitData()

  if (redirect) {
    return { hasRedirectParam: true, rootPath: redirect }
  }

  const rootPath = availableSections[MENU_POST_ITEM.uiSectionName]
    ? '/'
    : getWebappLinkPrefix(undefined, true)

  return { hasRedirectParam: false, rootPath }
}
